/** Erros típicos de extensões Chrome (chrome.runtime.onMessage) — não são do app. */
const EXTENSION_NOISE_RE =
  /listener indicated|message channel closed|asynchronous response|Extension context invalidated/i;

export function extensionNoiseMessage(reason) {
  if (reason == null) return "";
  if (typeof reason === "string") return reason;
  const parts = [reason.message, reason.stack, String(reason)].filter(Boolean);
  return parts.join(" ");
}

export function isExtensionNoise(reason) {
  return EXTENSION_NOISE_RE.test(extensionNoiseMessage(reason));
}
